module.exports = __webpack_public_path__ + "img/loader.79d5a6c3.svg";